import { Component, Suspense, lazy } from "react";
import { pasteUnwrapped } from "../lib/helpers";
import { RichText } from "./common";

// Editorn (TipTap) är stor och behövs bara av lärare. Den laddas därför först
// när en lärarruta visas, i en egen fil, så att studenternas sidor inte växer.
const RichTextEditor = lazy(() => import("./RichTextEditor"));

// Det ögonblick editorn laddas: texten som den kommer att se ut i rutan, så att
// läraren inte ser formateringstecknen blinka förbi
function LoadingBox({ value, placeholder, minHeight = 60, style, G, css }) {
  const lines = String(value ?? "").split("\n");
  return (
    <div aria-busy="true" style={{ ...css.textarea, padding: 0, minHeight: 0, resize: "none", ...style }}>
      <div style={{ height: 36, borderBottom: `1px solid ${G.border}` }} />
      <div style={{ padding: "10px 14px", minHeight, whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
        {value
          ? lines.map((l, i) => <p key={i} style={{ margin: i < lines.length - 1 ? "0 0 0.6em" : 0 }}><RichText text={l} /></p>)
          : <span style={{ color: G.muted }}>{placeholder}</span>}
      </div>
    </div>
  );
}

// Går editorn inte att ladda (t.ex. en flik som stått öppen över en ny
// version) fungerar en vanlig textruta med samma värde
function PlainTextArea({ value, onChange, placeholder, ariaLabel, minHeight = 60, style, autoFocus, css }) {
  return (
    <textarea style={{ ...css.textarea, minHeight, ...style }} value={value || ""} placeholder={placeholder} aria-label={ariaLabel} autoFocus={autoFocus}
      onChange={e => onChange(e.target.value)} onPaste={e => pasteUnwrapped(e, onChange)} />
  );
}

class EditorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

// Lärarens textruta för frågetext och återkoppling, med fetstil och kursiv
function RichTextField(props) {
  return (
    <EditorBoundary fallback={<PlainTextArea {...props} />}>
      <Suspense fallback={<LoadingBox {...props} />}>
        <RichTextEditor {...props} />
      </Suspense>
    </EditorBoundary>
  );
}

export { RichTextField };
